export default {
  FROM_WHOM: {
    values: [
      {
        name: "Tüm İlanlar",
        slug: "",
        id: "all",
        visibility: {
          all: true,
        },
      },
      {
        name: "Emlak Ofisinden",
        slug: "emlakcidan",
        id: "CORPORATE",
        type: "corporate",
        category: 12,
        visibility: {
          all: true,
          category: [],
        },
      },
      {
        name: "Sahibinden",
        slug: "sahibinden",
        id: "PERSONAL",
        type: "personal",
        visibility: {
          all: true,
          category: [],
        },
      },
      {
        name: "Müteahhitten",
        slug: "muteahhitten",
        id: "CONTRACTOR",
        type: "corporate",
        category: 13,
        visibility: {
          all: false,
          category: [
            {
              id: 1,
              tradeTypes: ["sale", "flat_for_land"],
            },
            {
              id: 2,
              tradeTypes: ["sale", "rent"],
            },
            {
              id: 3,
              tradeTypes: ["sale", "rent", "sublet"],
            },
            {
              id: 6,
              tradeTypes: ["sale"],
            },
          ],
        },
      },
      {
        name: "Proje Firmasından",
        slug: "projeler",
        id: "PROJECTS",
        type: "projects",
        isNew: true,
        visibility: {
          all: false,
          category: [
            {
              id: 2,
              tradeTypes: ["sale"],
            },
            {
              id: 3,
              tradeTypes: ["sale"],
            },
          ],
        },
      },
      {
        name: "Bankadan",
        slug: "bankadan",
        id: "BANK",
        type: "corporate",
        category: 14,
        visibility: {
          all: false,
          category: [
            {
              id: 1,
              tradeTypes: ["sale"],
            },
            {
              id: 2,
              tradeTypes: ["sale"],
            },
            {
              id: 3,
              tradeTypes: ["sale"],
            },
            {
              id: 6,
              tradeTypes: ["sale"],
            },
          ],
        },
      },
    ],
  },
};
